// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/base/general.scss
// module id = 421
// module chunks = 0